import Service from "../service";
const url = 'banner'
const banner = {
    get() {
        return Service.get(url);
    },
}
export default banner